import type {ValidationError} from 'src/contexts/validation-context/validation-context';

export const validateContentSize = (content: string): ValidationError | null => {
    const sizeInBytes = new Blob([content]).size;
    const sizeInMB = sizeInBytes / (1024 * 1024);

    let error = null;

    if (sizeInMB > 10) {
        error = {
            message: 'Content exceeds the 10 MB limit.',
            code: 'CONTENT_EXCEEDS_10MB',
            controlId: 'notification-content',
        };
    }

    return error;
};
